var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9132 4.0625C12.0561 3.24702 11.4286 2.5 10.6007 2.5H3.77331C2.9454 2.5 2.3179 3.24702 2.46079 4.0625",
    stroke: "#0066CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6244 2.5C10.6422 2.33808 10.6511 2.25709 10.6512 2.19022C10.6526 1.55045 10.1707 1.0129 9.53457 0.944638C9.46807 0.9375 9.38663 0.9375 9.22376 0.9375H5.15013C4.98723 0.9375 4.90577 0.9375 4.83927 0.944638C4.20316 1.0129 3.72127 1.55045 3.72266 2.19021C3.7228 2.25709 3.73167 2.33806 3.7494 2.5",
    stroke: "#0066CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 10.9375H5.3125",
    stroke: "#0066CC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17719 8.30813C0.898425 6.33088 0.759044 5.34228 1.35145 4.70239C1.94386 4.0625 2.99849 4.0625 5.10774 4.0625H9.26725C11.3765 4.0625 12.4311 4.0625 13.0236 4.70239C13.6159 5.34228 13.4766 6.33088 13.1978 8.30813L12.9334 10.1831C12.7148 11.7337 12.6056 12.5089 12.0448 12.9733C11.4841 13.4375 10.657 13.4375 9.00288 13.4375H5.3721C3.71801 13.4375 2.89096 13.4375 2.33021 12.9733C1.76947 12.5089 1.66016 11.7337 1.44155 10.1831L1.17719 8.30813Z",
    stroke: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7c5b7f8030e7f18bdfd435cc6817f7ae.svg";
export { ForwardRef as ReactComponent };